import { Dialog } from '@headlessui/react';
import ActionButton from '../components/basic/actionButton';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Button from '../components/basic/button';
import Icon from '../components/basic/icons';
import Image from '../components/basic/image';
import AlertSolidIcon from '../assets/actions/alert-solid.svg';

interface generalOperationErrorModal {
    isOpen : boolean;
    handleClose: () => void;
    errorMessage?: string;
}

export default function GeneralOperationErrorModal({
  isOpen,
  handleClose,
  errorMessage
}: generalOperationErrorModal): JSX.Element {
  const { t } = useTranslation();
  return (
    <Dialog as="div" open={isOpen} onClose={handleClose} data-testid="globalerrormodal-test">
      <div className="fixed inset-0 bg-black bg-opacity-25" />
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-full">
          <Dialog.Panel className="relative bg-white w-[330px] rounded-lg p-[16px] lg:p-[24px] md:w-[500px] lg:w-[700px]">
          <span className="text-[#0d1c3d] font-medium text-[26px]">{t('errorModal.title.error')}</span>
            <Button
              className="absolute flex flex-col items-center font-semibold right-6 top-6 text-secondary-300"
              onClick={handleClose}
            >
              <Icon name="close" className="text-2xl" />
            </Button>
            <div className="flex flex-col h-full space-y-base mt-sm">
              <div className="flex mt-4">
                 <Image src={AlertSolidIcon} alt="Alert Error Icon" className="mr-4 self-start" layout='fixed' />
                 <span className="text-slate-900 mt-2 text-lg">{errorMessage ? errorMessage: t('errorModal.msg.global')}</span>
              </div>
            <div className="text-right">
                <div className="md:inline-block">
                    <ActionButton
                        className="mt-2md sm:mt-2lg bg-secondary-200 w-full md:w-[80px] lg:mt-0"
                        type="button"
                        data-testid="okBtn"
                        onClick={handleClose}
                        >
                        {t('errorModal.btn.ok')}
                    </ActionButton>
                </div>
            </div>
              
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
